{
  "EMOJI": {
    "PLACEHOLDER": "Поиск эмодзи",
    "NOT_FOUND": "Эмодзи не соответствуют вашему запросу",
    "REMOVE": "Удалить"
  }
}
